import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const EditPricingDialog = ({ editingQuote, setEditingQuote, editPricing, setEditPricing, onSaveApprove, loading }) => {
  return (
    <Dialog open={!!editingQuote} onOpenChange={() => setEditingQuote(null)}>
      <DialogContent className="w-[90vw] max-w-md">
        <DialogHeader>
          <DialogTitle className="text-base md:text-lg">Adjust Quote Pricing</DialogTitle>
          <DialogDescription className="text-xs md:text-sm">
            Modify the AI-generated pricing before approving
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div>
              <Label className="text-xs md:text-sm">Min Price (£)</Label>
              <Input
                type="number"
                value={editPricing.price_min}
                onChange={(e) => setEditPricing(prev => ({ ...prev, price_min: e.target.value }))}
                placeholder={editingQuote?.price_min?.toString()}
                className="mt-1 text-sm"
              />
            </div>
            <div>
              <Label className="text-xs md:text-sm">Max Price (£)</Label>
              <Input
                type="number"
                value={editPricing.price_max}
                onChange={(e) => setEditPricing(prev => ({ ...prev, price_max: e.target.value }))}
                placeholder={editingQuote?.price_max?.toString()}
                className="mt-1 text-sm"
              />
            </div>
          </div>
          <div>
            <Label className="text-xs md:text-sm">Fixed Quote (£)</Label>
            <Input
              type="number"
              value={editPricing.total_cost}
              onChange={(e) => setEditPricing(prev => ({ ...prev, total_cost: e.target.value }))}
              placeholder={editingQuote?.total_cost?.toString()}
              className="mt-1 text-sm"
            />
          </div>
          <div>
            <Label className="text-xs md:text-sm">Admin Notes (internal)</Label>
            <Textarea
              value={editPricing.admin_notes}
              onChange={(e) => setEditPricing(prev => ({ ...prev, admin_notes: e.target.value }))}
              placeholder="Notes about pricing adjustments..."
              className="mt-1 text-sm"
            />
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => setEditingQuote(null)} className="w-full sm:w-auto text-sm">Cancel</Button>
          <Button
            className="btn-accent w-full sm:w-auto text-sm"
            onClick={() => onSaveApprove(editingQuote?.id)}
            disabled={loading}
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Save & Approve'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
